import PropTypes from 'prop-types';
import Container from '@mui/material/Container';
import useTheme from '@mui/styles/useTheme';

function PageContentContainer({
	ariaLabel = undefined,
	children,
	containerStyle = undefined,
	tabIndex = undefined,
}) {
	const theme = useTheme();
	const paddingTop = theme.spacing(2);
	const paddingRight = theme.spacing(3);
	const paddingBottom = theme.spacing(3);
	const paddingLeft = theme.spacing(3);

	const contentPaddingStyle = {
		paddingTop,
		paddingRight,
		paddingBottom,
		paddingLeft,
	};

	return (
		<Container
			maxWidth="xl"
			style={{ ...contentPaddingStyle, ...containerStyle }}
			aria-label={ariaLabel}
			tabIndex={tabIndex}
		>
			{children}
		</Container>
	);
}

PageContentContainer.propTypes = {
	ariaLabel: PropTypes.string,
	children: PropTypes.node.isRequired,
	containerStyle: PropTypes.object,
	tabIndex: PropTypes.number,
};

export default PageContentContainer;
